"use strict";
/*
 * © 2017 Renishaw plc. All rights reserved.
 * This source file is the confidential property and copyright of Renishaw plc
 * Reproduction or transmission in whole or in part, in any form or
 * by any means, electronic, mechanical or otherwise, is prohibited
 * without the prior written consent of the copyright owner.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.validEmailRegex = exports.DefaultTimeSeriesPrecision = exports.MaximumIntegerInput = exports.aliases = exports.toleranceTypes = exports.roles = exports.permissions = exports.systemPermissions = exports.machineConfigurationDefaults = exports.GCodeControllerMake = exports.machineConfigurationConnectionTypes = exports.machineConfigurationFixedValues = exports.commsTypes = exports.variableTypesForSiemens = exports.addressTypes = exports.UPTIME_STATES = exports.MachineState = exports.MachineModel = exports.Licensable = exports.ServiceType = exports.getMachineTypeAsString = exports.MachineType = exports.clipboard = exports.stringFunctions = exports.checks = exports.processCapability = exports.units = void 0;
exports.isAuthFailure = isAuthFailure;
exports.machineTypeMapper = machineTypeMapper;
exports.isMetrologyMachineType = isMetrologyMachineType;
exports.isEquatorX = isEquatorX;
exports.isEquator = isEquator;
exports.matchToMachineState = matchToMachineState;
exports.isJobMetrology = isJobMetrology;
exports.instanceOfMasteringUpdate = instanceOfMasteringUpdate;
exports.correctionTargetMapper = correctionTargetMapper;
exports.tidyConfigurationDetails = tidyConfigurationDetails;
exports.generateMachineConnectionPayload = generateMachineConnectionPayload;
exports.calculateNumberOfMachineConnectionPolls = calculateNumberOfMachineConnectionPolls;
exports.getCommunicationType = getCommunicationType;
const stringFunctions_1 = require("./stringFunctions");
exports.units = __importStar(require("./units"));
exports.processCapability = __importStar(require("./math/processCapability"));
exports.checks = __importStar(require("./math/checks"));
exports.stringFunctions = __importStar(require("./stringFunctions"));
exports.clipboard = __importStar(require("./clipboard"));
const uuid_1 = require("uuid");
function isAuthFailure(response) {
    return !!(response === null || response === void 0 ? void 0 : response.error);
}
//#endregion
//#region Machines
/** Broad categories of physical machine */
var MachineType;
(function (MachineType) {
    MachineType["Additive"] = "Additive";
    MachineType["CoordinateMeasurement"] = "CoordinateMeasurement";
    MachineType["Equator"] = "Equator";
    MachineType["MachineTool"] = "MachineTool";
    MachineType["Service"] = "Service";
    MachineType["Unknown"] = "Unknown";
})(MachineType || (exports.MachineType = MachineType = {}));
function machineTypeMapper(type) {
    switch (type.toLowerCase()) {
        case "coordinatemeasurement":
        case "cmm": {
            return MachineType.CoordinateMeasurement;
        }
        case "machinetool":
        case "machine tool": {
            return MachineType.MachineTool;
        }
        case "equator":
            return MachineType.Equator;
        case "additive":
        case "am":
            return MachineType.Additive;
        case "service":
            return MachineType.Service;
        default:
            return MachineType.Unknown;
    }
}
const getMachineTypeAsString = (type) => {
    switch (type.toString().toLowerCase()) {
        case "cmm":
        case "coordinatemeasurement":
            return "CMM";
        case "machinetool":
        case "machine tool":
            return "Machine Tool";
        case "equator":
            return "Equator";
        case "service":
            return "Service";
        case "am":
        case "additive":
            return "Additive";
        case "unknown":
            return "Unknown";
        default:
            return type.toString();
    }
};
exports.getMachineTypeAsString = getMachineTypeAsString;
/** Licensable entities which are not Machines */
var ServiceType;
(function (ServiceType) {
    ServiceType["Service"] = "Service";
    ServiceType["Other"] = "Other";
})(ServiceType || (exports.ServiceType = ServiceType = {}));
/** Entities which may be licensed */
exports.Licensable = { ...MachineType, ...ServiceType };
const MetrologyMachineTypes = [
    MachineType.CoordinateMeasurement,
    MachineType.Equator,
    MachineType.MachineTool,
];
function isMetrologyMachineType(machineType) {
    return MetrologyMachineTypes.includes(machineTypeMapper(machineType));
}
var MachineModel;
(function (MachineModel) {
    // equator
    MachineModel["Equator300"] = "Equator 300";
    MachineModel["Equator300EH"] = "Equator 300 EH";
    MachineModel["Equator500"] = "Equator 500";
    // additive
    MachineModel["AM250"] = "RenAM 250";
    MachineModel["AM400"] = "RenAM 400";
    MachineModel["AM500"] = "RenAM 500";
    MachineModel["AMRenAM500QAMPMFLEX"] = "RenAM 500Q AMPM FLEX";
    MachineModel["AMRenAM500QFLEX"] = "RenAM 500Q FLEX";
    MachineModel["AMRenAM500SAMPMFLEX"] = "RenAM 500S AMPM FLEX";
    MachineModel["AMRenAM500SFLEX"] = "RenAM 500S FLEX";
    MachineModel["AMRenAM500QULTRA"] = "RenAM 500Q ULTRA";
    MachineModel["AM500M"] = "RenAM 500M";
    MachineModel["AM500Q"] = "RenAM 500Q";
    MachineModel["Unknown"] = "Unknown";
})(MachineModel || (exports.MachineModel = MachineModel = {}));
function isEquatorX(model) {
    return model && /^eq(uator)?-x/i.test(model);
}
function isEquator(type) {
    return type && /^equator/i.test(type);
}
var MachineState;
(function (MachineState) {
    MachineState["CalibratingProbes"] = "Calibrating Probes";
    MachineState["Calibrating"] = "Calibrating";
    MachineState["Cooling"] = "Cooling";
    MachineState["Error"] = "Error";
    MachineState["ForcedIdle"] = "Forced Idle";
    MachineState["Idle"] = "Idle";
    MachineState["AwaitingInput"] = "Awaiting Input";
    MachineState["Offline"] = "Offline";
    MachineState["Running"] = "Running";
    MachineState["Stopped"] = "Stopped";
    MachineState["Unknown"] = "Unknown";
    MachineState["Build"] = "Build";
    MachineState["PoweredDown"] = "Powered Down";
    MachineState["Maintenance"] = "Maintenance";
    MachineState["Setup"] = "Setup";
    MachineState["Teardown"] = "Teardown";
    // EQUATOR STATUS
    MachineState["Mastering"] = "Mastering";
    MachineState["Measuring"] = "Measuring";
    // RAMTIC STATUS
    MachineState["Machining"] = "Machining";
    MachineState["WingTransfer"] = "Wing Transfer";
    MachineState["MICG"] = "Machining and ICG";
    MachineState["ToolLoad"] = "Tool Load";
    MachineState["ToolUnload"] = "Tool Unload";
    MachineState["CarouselEnd"] = "Carousel End";
    MachineState["Active"] = "Active";
    MachineState["Ready"] = "Ready";
    MachineState["Wait"] = "Wait";
    MachineState["Interrupted"] = "Interrupted";
    // GROUPED
    MachineState["Other"] = "Other";
})(MachineState || (exports.MachineState = MachineState = {}));
/** Finds a MachineState that loosely matches `state`.
 * Returns undefined if not found, so if you want to preserve unrecognised states, use `matchToMachineState(x) ?? x` */
function matchToMachineState(state) {
    if (state === null || state === undefined)
        return undefined;
    const machineStates = Object.values(MachineState);
    return machineStates.find((enumVal) => (0, stringFunctions_1.looseMatch)(enumVal, state));
}
exports.UPTIME_STATES = [
    MachineState.Running,
    MachineState.Measuring,
    MachineState.Machining,
];
exports.addressTypes = ["IP Address", "Hostname"];
exports.variableTypesForSiemens = ["R", "GUD"];
exports.commsTypes = ["ControllerApi", "FileDrop", "None"];
exports.machineConfigurationFixedValues = {
    type: "MachineConfiguration",
    subType: "MachineCommunicationSettings",
    name: "ControllerSettings",
};
exports.machineConfigurationConnectionTypes = [
    "Ethernet",
    "SerialBus",
];
exports.GCodeControllerMake = "G-Code Controller";
exports.machineConfigurationDefaults = {
    ...exports.machineConfigurationFixedValues,
    created: "1970-01-01T00:00:00Z",
    component: "Central IPC Service",
    active: true,
};
function isJobMetrology(job) {
    return (job.type !== "JobAdditiveSummary" &&
        job.type !== "JobAdditive" &&
        job.type !== "JobAdditiveSummaryExtended");
}
function instanceOfMasteringUpdate(object) {
    return ("subType" in object &&
        object.subType === "MasteringUpdate" &&
        "masterJobName" in object);
}
function correctionTargetMapper(correctionTarget) {
    switch (correctionTarget === null || correctionTarget === void 0 ? void 0 : correctionTarget.toLowerCase()) {
        case "length":
        case "toollength":
            return "L";
        case "radius":
        case "cutterradius":
            return "R";
        case "xaxis":
            return "X";
        case "yaxis":
            return "Y";
        case "zaxis":
            return "Z";
        case "noseradius":
            return "TNR";
        default:
            return "?";
    }
}
//#endregion
//#region Users
/** System permission levels */
exports.systemPermissions = [
    "dataAdmin",
    "fileCreator",
    "locationCreator",
    "machineCreator",
    "tenantAdmin",
];
/** Entity permission levels; "None" is a front-end representation of an absence of any permission on the back-end, and should not be sent to the API */
exports.permissions = ["None", "Read", "Admin"];
/** System user rôles */
exports.roles = ["Standard", "Admin", "Super Admin"];
exports.toleranceTypes = [
    "Angle",
    "AngleBetween",
    "AngleWithRespectTo",
    "Angularity",
    "BilateralPosition",
    "Circularity",
    "CircularRunout",
    "Composite",
    "CompositeLine",
    "CompositeSurface",
    "Concentricity",
    "Coordinate",
    "Cylindricity",
    "Diameter",
    "DistanceBetween",
    "DistanceWithRespectTo",
    "Flatness",
    "LeastMaterialCondition",
    "MaximumMaterialCondition",
    "Parallelism",
    "Perpendicularity",
    "ProfileOfALine",
    "ProfileOfAPoint",
    "ProfileOfASurface",
    "Radius",
    "Straightness",
    "SurfaceFinish",
    "Symmetry",
    "TotalRunout",
    "TruePosition",
    "Unknown",
    "Width",
];
/**
 * Known variations on tolerance names (letters only – case, spaces and punctuation are ignored)
 */
exports.aliases = {
    Angle: ["Angular", "DynamicAngular"],
    AngleBetween: [],
    AngleWithRespectTo: ["AngleWithRespect"],
    Angularity: [],
    BilateralPosition: [],
    Circularity: ["Roundness"],
    CircularRunout: ["Runout"],
    Composite: [
        "PositionComposite",
        "CompositeTolerance",
        "CompositePosition",
        "CompositePoint",
        "CompositeProfileOfAPoint",
    ],
    CompositeLine: ["LineComposite", "CompositeProfileOfALine"],
    CompositeSurface: ["SurfaceComposite", "CompositeProfileOfASurface"],
    Concentricity: [],
    Coordinate: [],
    Cylindricity: [],
    Diameter: [],
    DistanceBetween: [],
    DistanceWithRespectTo: ["DistanceWithRespect"],
    Flatness: ["SurfaceFlatness"],
    LeastMaterialCondition: [],
    MaximumMaterialCondition: [],
    Parallelism: [],
    Perpendicularity: [],
    ProfileOfALine: ["ProfileLine", "LineProfile"],
    ProfileOfAPoint: ["ProfilePoint", "PointProfile"],
    ProfileOfASurface: ["ProfileSurface", "SurfaceProfile"],
    Radius: ["Radial"],
    Straightness: [],
    SurfaceFinish: [],
    Symmetry: [],
    TotalRunout: [],
    TruePosition: ["Position"],
    Unknown: [""],
    Width: [],
};
// Maximum value that can be input into numeric fields based on
// the C# maximum integer value.
exports.MaximumIntegerInput = 2000000000;
// Default number of decimal places that time series data
// should be displayed in or rounded to.
exports.DefaultTimeSeriesPrecision = 3;
exports.validEmailRegex = /^(?=.{6,254}$)[-\w/.+%!#$&'*=?^{}|~]{1,64}@([-\w]+\.)+[-a-z]{2,32}$/i;
function tidyConfigurationDetails(details) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q;
    if (((_a = details.connectionInfo) === null || _a === void 0 ? void 0 : _a.connectionType) === "SerialBus") {
        (_b = details.connectionInfo) === null || _b === void 0 ? true : delete _b.ipAddress;
    }
    if (((_c = details.connectionInfo) === null || _c === void 0 ? void 0 : _c.connectionType) === "Ethernet" &&
        ((_d = details.controller) === null || _d === void 0 ? void 0 : _d.make) !== "Mitsubishi" &&
        ((_e = details.controller) === null || _e === void 0 ? void 0 : _e.make) !== "Citizen") {
        delete details.connectionInfo.deviceNumber;
    }
    if (!["Siemens", "Citizen"].includes((_f = details.controller) === null || _f === void 0 ? void 0 : _f.make)) {
        delete details.connectionInfo.connectionChannel;
    }
    if (((_g = details.controller) === null || _g === void 0 ? void 0 : _g.make) === "Siemens") {
        if (((_h = details.configurationInfo) === null || _h === void 0 ? void 0 : _h.variableType) === "R") {
            delete details.configurationInfo.gudArea;
        }
        else {
            delete details.configurationInfo.channel;
        }
    }
    else {
        delete details.configurationInfo.variableType;
        delete details.configurationInfo.gudArea;
    }
    if (((_j = details.controller) === null || _j === void 0 ? void 0 : _j.make) != "Heidenhain") {
        delete details.connectionInfo.series;
        delete details.configurationInfo.syncVariableKey;
        delete details.configurationInfo.alarmVariableKey;
        delete details.configurationInfo.overrideVariableKey;
    }
    if (((_k = details.connectionInfo) === null || _k === void 0 ? void 0 : _k.appName) === "" ||
        ((_l = details.controller) === null || _l === void 0 ? void 0 : _l.make) !== "Mazak") {
        delete details.connectionInfo.appName;
    }
    if (((_m = details.connectionInfo) === null || _m === void 0 ? void 0 : _m.appPassword) === "" ||
        ((_o = details.controller) === null || _o === void 0 ? void 0 : _o.make) !== "Mazak") {
        delete details.connectionInfo.appPassword;
    }
    if (((_p = details.connectionInfo) === null || _p === void 0 ? void 0 : _p.addressType) === "Hostname" &&
        ((_q = details.connectionInfo) === null || _q === void 0 ? void 0 : _q.hostname)) {
        details.connectionInfo.ipAddress = details.connectionInfo.hostname;
        delete details.connectionInfo.hostname;
    }
    return details;
}
function generateMachineConnectionPayload(machine, details) {
    // We may have to delete properties from the data passed in so a copy
    // is created so it does not effect the callers data.
    const detailsCopy = JSON.parse(JSON.stringify(details));
    if (detailsCopy.dispatchMethod) {
        delete detailsCopy.dispatchMethod;
    }
    if (details.dispatchMethod === "ControllerApi") {
        tidyConfigurationDetails(detailsCopy);
    }
    const payload = {
        created: new Date().toISOString(),
        type: "ServiceRequest",
        subType: "MachineConnectionRequest",
        name: "MachineToolConnectivityRequest",
        source: "Renishaw.IPC.WebApp",
        payloadVersion: "5.0.0",
        requestId: (0, uuid_1.v4)(),
        details: {
            machine: {
                id: machine.id,
                make: machine.make,
                name: machine.name,
                type: machine.type,
                model: machine.model,
                serialNumber: machine.serialNumber,
            },
            ...detailsCopy,
        },
    };
    return payload;
}
function calculateNumberOfMachineConnectionPolls(connectionTimeout) {
    // Five is added as the connection timeout refers to the timeout for the
    // IPC engine to communicate with the machine tool. As the check polls
    // once a second this equates to 5 extra seconds of polling. This extra
    // time is enough for the engine to kick off its request and return a
    // value to the FE.
    return connectionTimeout + 5;
}
function getCommunicationType(system) {
    const comms = (system === null || system === void 0 ? void 0 : system.communicationType.toLowerCase()) || "";
    const commsType = comms.includes("email")
        ? "Email"
        : comms.includes("files")
            ? "Files"
            : "Email";
    return commsType;
}
//# sourceMappingURL=index.js.map